import { WecomAcceptFriendData } from "../../handler/wecom/ws-types";
import EventBus from "../event-bus";
const acceptFriendHook = new EventBus<WecomAcceptFriendData>(
  "acceptFriendHook"
);

export default acceptFriendHook;
